/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  GuardrailConfig,
  GuardrailConfig$inboundSchema,
  GuardrailConfig$Outbound,
  GuardrailConfig$outboundSchema,
} from "./guardrailconfig.js";

export type GetGuardrailsResponse = {
  object: "guardrails_settings";
  guardrails: Array<GuardrailConfig>;
};

/** @internal */
export const GetGuardrailsResponse$inboundSchema: z.ZodType<
  GetGuardrailsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("guardrails_settings"),
  guardrails: z.array(GuardrailConfig$inboundSchema),
});
/** @internal */
export type GetGuardrailsResponse$Outbound = {
  object: "guardrails_settings";
  guardrails: Array<GuardrailConfig$Outbound>;
};

/** @internal */
export const GetGuardrailsResponse$outboundSchema: z.ZodType<
  GetGuardrailsResponse$Outbound,
  z.ZodTypeDef,
  GetGuardrailsResponse
> = z.object({
  object: z.literal("guardrails_settings"),
  guardrails: z.array(GuardrailConfig$outboundSchema),
});

export function getGuardrailsResponseToJSON(
  getGuardrailsResponse: GetGuardrailsResponse,
): string {
  return JSON.stringify(
    GetGuardrailsResponse$outboundSchema.parse(getGuardrailsResponse),
  );
}
export function getGuardrailsResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetGuardrailsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetGuardrailsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetGuardrailsResponse' from JSON`,
  );
}
